import styled from '@emotion/styled';


export const ChatWrapper = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  height: 100%;
  position: relative;
`;